import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { v4 } from "uuid";

export type BuildSetting = {
    _id: string;
    buildId: string;
    buildSettingsKeyId: string;
    companyId: string;
    key: string;
    organizationId: string;
    value: string;
};

export type BuildSettingsKey = {
    _id: string;
    buildId: string;
    organizationId: string;
    companyId: string;
    key: string;
    dataType: string;
    label: string;
    placeholder: string;
    description: string;
    guid: string;
};

export type NewBuildSettingKey = {
    buildId: string;
    organizationId: string;
    companyId: string;
    dataType: string;
    label: string;
    placeholder?: string;
    description?: string;
    key?: string;
};

type BuildSettingsKeyUpdate = {
    label?: string;
    placeholder?: string;
    description?: string;
};

interface InitialState {
    [key: string]: Partial<BuildSettingsKey>;
}

const initialState: InitialState = {};

const buildSettingsKeySlice = createSlice({
    name: "buildSettingsKey",
    initialState: initialState,
    reducers: {
        addBuildSettingsKey: (state, action: PayloadAction<NewBuildSettingKey>) => {
            const newBSKKey = action.payload.key ? action.payload.key : `buildSettingsKey.${v4()}`;
            state[newBSKKey] = {
                ...action.payload,
                key: newBSKKey,
                guid: v4()
            };
        },
        updateBuildSettingsKey: (state, action: PayloadAction<{ key: string; update: BuildSettingsKeyUpdate }>) => {
            if (state[action.payload.key]) {
                state[action.payload.key] = {
                    ...state[action.payload.key],
                    ...action.payload.update
                };
            }
        },
        deleteBuildSettingsKey: (state, action: PayloadAction<string>) => {
            if (state[action.payload]) {
                delete state[action.payload];
            }
        },
        resetBuildSettingsKey: (_, action: PayloadAction<InitialState>) => {
            return action.payload;
        }
    }
});

export default buildSettingsKeySlice.reducer;
export const { addBuildSettingsKey, updateBuildSettingsKey, deleteBuildSettingsKey, resetBuildSettingsKey } = buildSettingsKeySlice.actions;
